export { default } from '../TextLabel';
